import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "../Reveal";
import { api, formatApiError } from "../../lib/api";

export const Newsletter = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post("/subscribe", { name, email });
      toast.success(res.data.message === "already_subscribed"
        ? "You're already part of the community."
        : "Welcome aboard — your welcome email is on its way.");
      setName(""); setEmail("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section id="join" className="py-20 md:py-28" data-testid="newsletter-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2.5rem] bg-ember px-6 py-16 sm:px-12 md:px-20 md:py-24" data-testid="newsletter-block">
            <svg className="absolute -right-16 -top-16 h-72 w-72 text-white/10" viewBox="0 0 100 100" fill="none">
              <circle cx="50" cy="50" r="48" stroke="currentColor" strokeWidth="1.5" />
              <circle cx="50" cy="50" r="34" stroke="currentColor" strokeWidth="1.5" />
              <circle cx="50" cy="50" r="20" stroke="currentColor" strokeWidth="1.5" />
            </svg>
            <div className="relative max-w-2xl">
              <p className="font-mono text-xs uppercase tracking-[0.22em] text-white/80 font-semibold">Join the community</p>
              <h2 className="mt-5 font-serif font-semibold text-cream text-3xl sm:text-4xl lg:text-5xl leading-[1.12]" data-testid="newsletter-heading">
                One email a week. Zero jargon. Yours free.
              </h2>
              <p className="mt-5 text-white/85 leading-relaxed max-w-lg">
                A plain-English lesson, a money or safety tip, and first access to free workshops —
                written for women learning AI on their own terms.
              </p>
              <form onSubmit={submit} className="mt-9 flex flex-col sm:flex-row gap-3" data-testid="newsletter-form">
                <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="First name (optional)"
                       data-testid="newsletter-name-input"
                       className="sm:w-48 rounded-full border border-white/30 bg-white/10 px-6 py-4 text-sm text-cream placeholder:text-white/60 focus:outline-none focus:ring-2 focus:ring-white/50 transition-colors duration-300" />
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address"
                       data-testid="newsletter-email-input"
                       className="flex-1 rounded-full border border-white/30 bg-white/10 px-6 py-4 text-sm text-cream placeholder:text-white/60 focus:outline-none focus:ring-2 focus:ring-white/50 transition-colors duration-300" />
                <button type="submit" disabled={busy} data-testid="newsletter-submit-button"
                        className="inline-flex items-center justify-center gap-2 rounded-full bg-ink text-cream text-sm font-semibold px-8 py-4 hover:bg-stone-800 transition-colors duration-300 disabled:opacity-60">
                  {busy ? "Joining…" : <>Join <ArrowRight size={16} /></>}
                </button>
              </form>
              <p className="mt-4 text-xs text-white/70">We never share your address. Unsubscribe anytime.</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
